import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogActions, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { NotificationMessageComponent } from 'src/app/shared/components/notification/notification-message/notification-message.component';
import { BillingService } from 'src/app/core/services/billing.service';
import { OverlayContainer } from '@angular/cdk/overlay';
import { UntypedFormGroup, UntypedFormControl, FormsModule } from '@angular/forms';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatIconRegistry, MatIcon } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationDialogComponent } from 'src/app/shared/components/notification/notification-dialog/notification-dialog.component';
import { environment } from 'src/environments/environment';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';


declare var Stripe: any;
@Component({
    selector: 'app-stripe-dialog',
    templateUrl: './stripe-dialog.component.html',
    styleUrls: ['./stripe-dialog.component.scss'],
    standalone: true,
    imports: [
      MatIcon,
      MatProgressSpinner,
      FormsModule,
      MatDialogActions,
      MatDialogTitle,
      MatDialogContent,
      MatButton,
      MatIconButton
    ]
})
export class StripeDialogComponent implements OnInit, OnDestroy {

  invoiceId: string;
  stripePublicKey = '';
  intentSecret: string;
  titleClass: string;
  form: UntypedFormGroup;
  total: string;
  hasData = false;
  loading = false;
  stripePresence = '';

  // tslint:disable-next-line: max-line-length
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    private billingService: BillingService,
    public overlayContainer: OverlayContainer,
    public breakpointObserver: BreakpointObserver,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer) {

    overlayContainer.getContainerElement().classList.remove('mini-calendar-dialog_overlay');
    overlayContainer.getContainerElement().classList.add('stripe-dialog_overlay');

    this.matIconRegistry.addSvgIcon(
      'close_icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(environment.base + 'assets/images/icons/close_icon.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'lock_icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(environment.base + 'assets/images/icons/lock_icon.svg')
    );

  }

  ngOnInit(): void {
    this.total = this.data['invoiceTotal'];
    this.breakpointObserver.observe([
      Breakpoints.Handset,
      Breakpoints.Tablet
    ]).subscribe(result => {
      if (result.matches) {
        this.setMobileLayout();
      } else {
        this.setDesktopLayout();
      }
    });

    this.loadStripe();

    this.form = new UntypedFormGroup({
      stripeInfo: new UntypedFormControl('')
    });
  }

  loadStripe() {
    this.hasData = false;
    if (this.data['stripePublicKey'] !== '') {
      this.hasData = true;
      const stripe = Stripe(this.data['stripePublicKey']);

      // Card element that will watch for updates
      // and display error messages
      const elements = stripe.elements();
      const card = elements.create('card');
      card.mount('#card-element');

      card.addEventListener('change', event => {

        const displayError = document.getElementById('card-errors');
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
        }

      });

      // Listen for form submission, process the form with Stripe,
      // and get the paymentIntent properties
      const paymentForm = document.getElementById('payment-form');
      paymentForm.addEventListener('submit', event => {

        this.loading = true;

        event.preventDefault();
        stripe.confirmCardPayment(this.data['intentSecret'],
          {
            payment_method: {
              card
            }
          }).then(paymentResult => {

            if (paymentResult['paymentIntent'] === undefined) {
              this.loading = false;
              return;
            }
            if (paymentResult['paymentIntent'].error) {

              this.dialog.open(NotificationMessageComponent, {
                data: { heading: 'Failed', body: 'Error creating payment', type: 'danger' }
              });

              const errorElement = document.getElementById('card-errors');
              errorElement.textContent = paymentResult.error.message;

              this.loading = false;

            } else {

              this.billingService.sendPaymentLoad(paymentResult['paymentIntent'], this.data.invoiceId).subscribe((response) => {
                if (response) {
                  this.loading = false;
                  // Pass type to determine the type of dialog to display - success, celebration
                  this.dialog.open(NotificationDialogComponent, {
                    data: {
                      message: 'You payment has been successfully processed.',
                      type: 'success'
                    }
                  });
                  this.dialogRef.close({ event: 'close', data: response['stripe_api_key_presence'] });
                  this.router.navigate(['billing']);
                }
              }, err => {
                console.error('PAYMENT NOT SENT TO SERVER', err);
              });
            }
          });
      });
    }
  }

  setMobileLayout() {
    this.dialogRef.updateSize('90vw', 'auto'); // Responsive width for mobile
  }

  setDesktopLayout() {
    this.dialogRef.updateSize('500px', 'auto'); // Better width for desktop with auto height
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closeDialog() {
    this.dialogRef.close({ event: 'close' });
  }

  ngOnDestroy(): void {
    this.overlayContainer.getContainerElement().classList.remove('stripe-dialog_overlay');
  }
}
